<div class="pricing-grid">
  <h2 class="heading__regular--xxs udex-mb-20">
    {{ 'productDetails.pricingDetails' | cxTranslate }}
  </h2>
  <!-- One Time Set up Fees -->
  @if (!!ratePlan?.setupFees?.length) {
    <div class="pricing-grid__headline heading__regular--xxxxs">
      {{ 'productDetails.oneTime' | cxTranslate }}
    </div>
    @for (setupFee of ratePlan?.setupFees; track setupFee.id; let i = $index) {
      <span [class.pt-2]="i > 0" [class.pt-3]="i == 0" class="body--xxs pricing-grid__left text-capitalize">{{
        setupFee.metric?.name + ':'
      }}</span>
      <span [class.pt-2]="i > 0" [class.pt-3]="i == 0" class="body--xxs pricing-grid__right">{{
        ratePlan?.currency + ' ' + (setupFee.price?.amount | priceFormat)
      }}</span>
    }
  }
  <!-- Price periodicity -->
  @if (!!ratePlan?.periodicity?.name) {
    @if (ratePlan?.setupFees?.length) {
      <div class="my-4 separator pricing-grid__headline w-100"></div>
    }
    <span class="pricing-grid__headline heading__regular--xxxxs text-capitalize">{{
      'productDetails.perUnit' | cxTranslate: {unit: ratePlan?.periodicity?.name}
    }}</span>
  }
  <!-- Plan block rate -->
  @for (blockRate of ratePlan?.blockRates; track blockRate.id; let i = $index) {
    <span [class.pt-2]="i > 0" [class.pt-3]="i == 0" class="body--xxs pricing-grid__left text-capitalize">{{
      'productDetails.perAmountOfUnit'
        | cxTranslate
          : {
              amount: blockRate.blockSize,
              unit: blockRate.metric?.name,
            }
    }}</span>
    <span [class.pt-2]="i > 0" [class.pt-3]="i == 0" class="body--xxs pricing-grid__right">{{
      ratePlan?.currency + ' ' + (blockRate.pricePerBlock?.amount | priceFormat)
    }}</span>
  }
  <!-- Plan fix rate -->
  @for (fixedRate of ratePlan?.fixedRates; track fixedRate.id; let i = $index) {
    <span
      [class.pt-2]="i > 0 || ratePlan?.blockRates?.length"
      [class.pt-4]="i == 0 && !ratePlan?.blockRates?.length"
      class="body--xxs pricing-grid__left text-capitalize"
      >{{ fixedRate.metric?.name + ':' }}</span
    >
    <span
      [class.pt-2]="i > 0 || ratePlan?.blockRates?.length"
      [class.pt-4]="i == 0 && !ratePlan?.blockRates?.length"
      class="body--xxs pricing-grid__right"
      >{{ ratePlan?.currency + ' ' + (fixedRate.price?.amount | priceFormat) }}</span
    >
  }
  <!-- Plan all unit volume rates -->
  @for (allUnitVolumeRate of ratePlan?.allUnitVolumeRates; track allUnitVolumeRate.id) {
    <span class="pt-4 body--xxs pricing-grid__left">
      <span class="text-capitalize">{{ allUnitVolumeRate.metric?.name }}</span>
      <span>{{ '(s)' }}</span>
    </span>
    <span class="pt-4 body--xxs pricing-grid__right">{{
      (allUnitVolumeRate.blockSize > 1
        ? 'productDetails.pricePerAmountOfUnitsPerPeriod'
        : 'productDetails.pricePerUnitPerPeriod'
      )
        | cxTranslate
          : {
              amount: allUnitVolumeRate.blockSize,
              unit: allUnitVolumeRate.metric?.name,
              period: ratePlan.periodicity?.name,
            }
    }}</span>
    @for (tier of allUnitVolumeRate.tiers; track $index; let i = $index) {
      <!-- number of users -->
      @if (i === 0 && allUnitVolumeRate?.tiers?.length === 1) {
        <span class="pt-2 body--xxs pricing-grid__left">{{ allUnitVolumeRate.minimumBlocks + '+' }}</span>
      }
      @if (i === 0 && allUnitVolumeRate?.tiers?.length > 1) {
        <span class="pt-2 body--xxs pricing-grid__left">{{
          allUnitVolumeRate.minimumBlocks + ' - ' + tier.bound
        }}</span>
      }
      @if (i > 0 && i < allUnitVolumeRate.tiers.length - 1) {
        <span class="pt-2 body--xxs pricing-grid__left">{{
          allUnitVolumeRate.tiers[i - 1].bound +
            1 +
            ' -
    ' +
            tier.bound
        }}</span>
      }
      @if (i !== 0 && i === allUnitVolumeRate.tiers.length - 1) {
        <span class="pt-2 body--xxs pricing-grid__left">{{ allUnitVolumeRate.tiers[i - 1].bound + 1 + '+' }}</span>
      }
      <!-- cost -->
      <span class="pt-2 body--xxs pricing-grid__right">{{
        ratePlan?.currency + ' ' + (tier.pricePerBlock?.amount | priceFormat)
      }}</span>
    }
  }
  <!-- Plan tier rates -->
  @for (tierRate of ratePlan?.tierRates; track tierRate.id) {
    <span class="pt-4 body--xxs pricing-grid__left">
      <span class="text-capitalize">{{ tierRate.metric?.name }}</span>
      <span>{{ '(s)' }}</span>
    </span>
    <span class="pt-4 body--xxs pricing-grid__right">{{
      'productDetails.pricePerUnitPerPeriod'
        | cxTranslate
          : {
              unit: tierRate.metric?.name,
              period: ratePlan?.periodicity?.name,
            }
    }}</span>
    @for (tier of tierRate?.tiers; track $index; let i = $index) {
      <!-- number of users -->
      @if (i === 0 && tierRate?.tiers?.length === 1) {
        <span class="pt-2 body--xxs pricing-grid__left"
          >{{ ('productDetails.first' | cxTranslate) + ' ' }}
          <span>{{ tierRate?.minimumBlocks + '+' }}</span>
        </span>
      }
      @if (i === 0 && tierRate?.tiers?.length > 1) {
        <span class="pt-2 body--xxs pricing-grid__left"
          >{{ ('productDetails.first' | cxTranslate) + ' ' }}
          <span>{{ tierRate?.minimumBlocks + ' - ' + tier.bound }}</span>
        </span>
      }
      @if (i > 0 && i < tierRate?.tiers.length - 1) {
        <span class="pt-2 body--xxs pricing-grid__left"
          >{{ ('productDetails.next' | cxTranslate) + ' ' }}
          <span>{{ tierRate?.tiers[i - 1].bound + 1 + ' - ' + tier.bound }}</span>
        </span>
      }
      @if (i !== 0 && i === tierRate?.tiers.length - 1) {
        <span class="pt-2 body--xxs pricing-grid__left"
          >{{ ('productDetails.next' | cxTranslate) + ' ' }}
          <span>{{ tierRate?.tiers[i - 1].bound + 1 + '+' }}</span>
        </span>
      }
      <!-- cost -->
      <span class="pt-2 body--xxs pricing-grid__right">{{
        ratePlan?.currency + ' ' + (tier.pricePerBlock?.amount | priceFormat)
      }}</span>
    }
  }
  <!-- Plan percentage rates (termination) -->
  @if (
    terminationRatePlanCommon?.percentageFees?.length ||
    terminationRatePlanCommon?.fixedRates?.length ||
    terminationRatePlanByCurrency?.percentageFees?.length ||
    terminationRatePlanByCurrency?.fixedRates?.length
  ) {
    <div class="my-4 separator pricing-grid__headline w-100"></div>
    <span class="pricing-grid__headline heading__regular--xxxxs">{{
      'productDetails.cancellationFee' | cxTranslate
    }}</span>
    @for (percentageFee of terminationRatePlanCommon?.percentageFees; track percentageFee.id; let i = $index) {
      <span [class.pt-2]="i > 0" [class.pt-3]="i === 0" class="body--xxs pricing-grid__left text-capitalize">{{
        percentageFee.metric?.name + ':'
      }}</span>
      <span [class.pt-2]="i > 0" [class.pt-3]="i === 0" class="body--xxs pricing-grid__right">{{
        percentageFee.ratio * 100 + '%'
      }}</span>
    }
    @for (fixedRate of terminationRatePlanByCurrency?.fixedRates; track fixedRate.id; let i = $index) {
      <span
        [class.pt-2]="i > 0 || terminationRatePlanCommon?.percentageFees?.length"
        [class.pt-3]="i === 0 && !terminationRatePlanCommon?.percentageFees?.length"
        class="body--xxs pricing-grid__left text-capitalize"
        >{{ fixedRate.metric?.name + ':' }}</span
      >
      <span
        [class.pt-2]="i > 0 || terminationRatePlanCommon?.percentageFees?.length"
        [class.pt-3]="i === 0 && !terminationRatePlanCommon?.percentageFees?.length"
        class="body--xxs pricing-grid__right"
        >{{ ratePlan?.currency + ' ' + (fixedRate.price?.amount | priceFormat) }}</span
      >
    }
  }
</div>
